"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonsWithIcons = void 0;
const react_1 = require("@chakra-ui/react");
const faAddressBook_1 = require("@fortawesome/free-solid-svg-icons/faAddressBook");
const faBreadSlice_1 = require("@fortawesome/free-solid-svg-icons/faBreadSlice");
const faTrash_1 = require("@fortawesome/free-solid-svg-icons/faTrash");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_2 = __importDefault(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const ButtonsWithIcons = () => (react_2.default.createElement(react_1.HStack, { align: 'center', spacing: 5 },
    react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Primary, { leftIcon: 'edit', text: 'Edit', onClick: () => {
            alert('Clicked!');
        } }),
    react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Secondary, { leftIcon: react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faAddressBook_1.faAddressBook }), text: 'Address Book', onClick: () => {
            alert('Clicked!');
        } }),
    react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Secondary, { leftIcon: react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faBreadSlice_1.faBreadSlice }), text: 'Bread Slice', onClick: () => {
            alert('Clicked!');
        } }),
    react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Danger, { text: 'Delete', leftIcon: react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faTrash_1.faTrash }), onClick: () => {
            alert('Clicked!');
        } }),
    react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Danger, { text: 'Cancel Subscription', leftIcon: 'trash', onClick: () => {
            alert('Clicked!');
        } }),
    react_2.default.createElement(UiKitLite_1.UiKitLite.Button.DangerBorderless, { text: 'Revert', rightIcon: 'history', onClick: () => {
            alert('Clicked!');
        } }),
    react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Cancel, { text: UiKitLite_1.UiKitLite.commonStrings.cancel, rightIcon: 'times', onClick: () => {
            alert('Clicked!');
        } })));
exports.ButtonsWithIcons = ButtonsWithIcons;
